import React from "react"
import PropTypes from "prop-types"

export default function TypeConditionalNumberOutcomes({ value }) {
  return <div className="outcomes-values">{value} </div>
}

TypeConditionalNumberOutcomes.propTypes = {
  value: PropTypes.string.isRequired,
}
